// Iter34 — Theme system: Light / Dark / System (auto).
// Applies data-theme="light" or data-theme="dark" to <html>.
// Persists to localStorage.sitroom_theme + syncs to user.theme via PATCH /me.
//
// The applyStoredTheme() call below runs BEFORE React mounts, so the first
// paint already has the correct theme — no white flash on dark.
const STORAGE_KEY = "sitroom_theme";
export const THEMES = ["light", "dark", "auto"];

const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";

const systemPrefersDark = () =>
  isBrowser && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

const resolveEffective = (choice) => {
  if (choice === "light" || choice === "dark") return choice;
  return systemPrefersDark() ? "dark" : "light";
};

/** Read the user's preference from localStorage. Defaults to "auto". */
export const readStoredTheme = () => {
  if (!isBrowser) return "auto";
  const v = localStorage.getItem(STORAGE_KEY);
  return THEMES.includes(v) ? v : "auto";
};

/** Apply a theme choice (light | dark | auto) to <html data-theme=…>. */
export const applyTheme = (choice) => {
  if (!isBrowser) return;
  const effective = resolveEffective(choice);
  document.documentElement.setAttribute("data-theme", effective);
};

/** Persist + apply. */
export const setTheme = (choice) => {
  if (!THEMES.includes(choice)) return;
  if (isBrowser) localStorage.setItem(STORAGE_KEY, choice);
  applyTheme(choice);
};

/** Apply whatever's currently in storage. Safe to call before React mounts. */
export const applyStoredTheme = () => applyTheme(readStoredTheme());

let _mediaListenerInstalled = false;
/** Re-resolve when the OS theme changes — only meaningful for "auto". */
export const installSystemListener = () => {
  if (!isBrowser || _mediaListenerInstalled) return;
  if (!window.matchMedia) return;
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  const handler = () => {
    if (readStoredTheme() === "auto") applyTheme("auto");
  };
  if (mq.addEventListener) mq.addEventListener("change", handler);
  else mq.addListener(handler); // Safari < 14
  _mediaListenerInstalled = true;
};
